import Neweast1 from '../../Media/Ruko/new east.webp'
import Neweast2 from '../../Media/Ruko/new east.webp'


const Neweastimages =[
Neweast1,Neweast2
]

export default Neweastimages;